module.exports = __webpack_public_path__ + "img/Signal_64x64.4b97a43c.png";